export const getModals = state => state.modals;
